module.exports = __webpack_public_path__ + "img/certificate_foreground.4f7874b1.svg";